export function getMappedValue<T extends keyof never, V = string>(
  valuePerSelectedType: Record<T, V>,
  selected: T,
  defaultValue?: V,
): V | undefined {
  return valuePerSelectedType[selected] || defaultValue;
}
